<template>
  <div class="upload-common">
    <div class="upload-half" v-loading="loading" v-if="type == 'half'">
      <lls-upload class="upload-demo" list-type="picture-card" :show-file-list="true" :file-list="fileList" drag action=""
        multiple :thumbnail="thumbnail" ref="uploadFile" :http-request="uploadFile" :on-preview="handlePictureCardPreview"
        :on-remove="handleRemove" :disabled="disabled" :limit="limit" :on-exceed="handleExceed">
        <div class="lls-upload__text" slot="trigger">
          <i class="lls-icon-upload"></i>{{ $t('kycFile.kycUpload.dropFile') }}
          <span>{{ $t('kycFile.kycUpload.browse') }}</span>
        </div>
      </lls-upload>
    </div>
    <div class="upload-all" v-loading="loading" v-else>
      <lls-upload class="upload-demo" list-type="picture-card" :show-file-list="true" :file-list="fileList" drag action=""
        multiple :thumbnail="thumbnail" ref="uploadFile" :http-request="uploadFile" :on-preview="handlePictureCardPreview"
        :on-remove="handleRemove" :disabled="disabled" :limit="limit" :on-exceed="handleExceed">
        <div class="lls-upload__text" slot="trigger">
          <i class="lls-icon-upload"></i>{{ $t('kycFile.kycUpload.dropFile') }}
          <span>{{ $t('kycFile.kycUpload.browse') }}</span>
        </div>
        <div class="lls-upload__tip" slot="tip" style="color: #89929E;" v-html="$t('kycFile.kycUpload.tip')"></div>
      </lls-upload>
    </div>
    <ImageViewer v-if="showImageViewer" :urlList="urls" :on-close="handleClose"></ImageViewer>
  </div>
</template>

<script>
import ImageViewer from "@/components/ImageViewer/ImageViewer.vue";
export default {
  name: "kycUpload",
  props: ["type", "mediaId", "modelCode", "catgId", "disabled", "limit", 'currentIndex'],
  components: {
    ImageViewer,
  },
  data() {
    return {
      fileList: [],
      loading: false,
      pdfShow: false,
      dialogImageUrl: "",
      dialogVisible: false,
      thumbnail: {
        pdf: require("@/static/kjaccSonImg/pdf.png"),
        png: require("@/static/kjaccSonImg/jpg.png"),
        jpg: require("@/static/kjaccSonImg/jpg.png"),
        jpeg: require("@/static/kjaccSonImg/jpg.png"),
        doc: require("@/static/kjaccSonImg/word.png"),
        xls: require("@/static/kjaccSonImg/excel.png"),
        default: require("@/static/kjaccSonImg/file.png"),
      },
      showImageViewer: false,
      urls: [],
    };
  },
  watch: {
    catgId(newVal, oldVal) {
      if (newVal) {
        this.showFileByCatgIdBusiKey();
      }
    },
    mediaId(newVal, oldVal) {
      if (newVal) {
        this.showFileByCatgIdBusiKey();
      }
    },
  },
  methods: {
    closeDia() {
      this.dialogImageUrl = "";
      console.log(this.dialogImageUrl, "11");
    },
    uploadFile(item) {
      var _this = this;
      console.log(item);
      let fileName = item.file.name || '';
      let pos = fileName.lastIndexOf(".");
      let lastName = fileName.substring(pos, fileName.length);
      if (
        lastName.toLowerCase() !== ".pdf" &&
        lastName.toLowerCase() !== ".jpg" &&
        lastName.toLowerCase() !== ".jpeg" &&
        lastName.toLowerCase() !== ".png" &&
        lastName.toLowerCase() !== ".bmp"
      ) {
        this.$message.error(this.$t('kycFile.kycUpload.fileTypeMust'));
        let uid = item.file.uid;
        let idx = this.$refs.uploadFile.uploadFiles.findIndex(item => item.uid === uid);
        this.$refs.uploadFile.uploadFiles.splice(idx, 1);
        return false;
      }
      // 获取上传文件大小
      let fileSize = Number(item.file.size / 1024 / 1024) || '';
      if (fileSize > 10) {
        this.$message.error(this.$t('kycFile.kycUpload.fileSizeNotExceed'));
        let uid = item.file.uid;
        let idx = this.$refs.uploadFile.uploadFiles.findIndex(item => item.uid === uid);
        this.$refs.uploadFile.uploadFiles.splice(idx, 1);
        return false;
      }
      const form = new FormData();
      form.append("file", item.file);
      this.loading = true;
      // 上传营业执照或身份证，调用ocr接口
      if (this.catgId == "CENT005" || this.catgId == "CCONTACT001" || this.catgId == "CCONTACT002") {
        this.$API.kycFile
          .uploadFileOCR(this.mediaId, this.modelCode, this.catgId, form, fileName)
          .then(
            (data) => {
              if (data.data.code == "200") {
                let tl = data.data.data || {};
                tl.mediaFile.url = tl.mediaFile.path;
                tl.mediaFile.name = tl.mediaFile.specifyFileName || tl.mediaFile.fileRename || tl.mediaFile.fileName;
                this.fileList.push(tl.mediaFile);
                let ocrObj = tl.ocrResult.data || {};
                _this.$emit("toOcr", ocrObj, this.currentIndex);
              }
              this.loading = false;
            },
            (response) => {
              let uid = item.file.uid;
              let idx = this.$refs.uploadFile.uploadFiles.findIndex(item => item.uid === uid);
              this.$refs.uploadFile.uploadFiles.splice(idx, 1);
              this.loading = false;
            }
          );
      } else {
        this.$API.kycFile
          .uploadFile(this.mediaId, this.modelCode, this.catgId, form, fileName)
          .then(
            (data) => {
              if (data.data.code == "200") {
                let tl = data.data.data || {};
                tl.name = tl.specifyFileName || tl.fileRename || tl.fileName;
                tl.url = tl.path;
                this.fileList.push(tl);
                this.$emit("toIdent");
              }
              this.loading = false;
            },
            (response) => {
              let uid = item.file.uid;
              let idx = this.$refs.uploadFile.uploadFiles.findIndex(item => item.uid === uid);
              this.$refs.uploadFile.uploadFiles.splice(idx, 1);
              this.loading = false;
            }
          );
      }
    },
    // 查询显示影像
    async showFileByCatgIdBusiKey() {
      this.loading = true;
      await this.$API.kycFile
        .showFileByCatgIdBusiKey(this.mediaId, this.modelCode, this.catgId, {})
        .then(
          (data) => {
            if (data.data.code == "200") {
              let tl = data.data.data || [];
              tl.map((item) => {
                item.url = item.path;
                item.name = item.specifyFileName || item.fileRename || item.fileName;
              });
              console.log(tl);
              this.fileList = tl;
            }
            this.loading = false;
          },
          (response) => {
            this.loading = false;
          }
        );
    },
    handleRemove(file, fileList) {
      console.log(file);
      // console.log(fileList);
      if (!file.id) {
        return;
      }
      this.loading = true;
      this.$API.kycFile.deleteFileByFileId(this.modelCode, file.id, {}).then(
        (data) => {
          if (data.data.code == "200") {
            console.log(this.fileList, "22");
            this.fileList.map((item, index) => {
              if (file.id == item.id) {
                this.fileList.splice(index, 1);
              }
            });
            console.log(this.fileList, "32");
            this.$emit("toIdent");
          }
          this.loading = false;
        },
        (response) => {
          this.loading = false;
        }
      );
    },
    handlePictureCardPreview(file) {
      this.urls = [];
      console.log(file);
      let urlObj = {};
      urlObj.title = file.fileRename;
      urlObj.url = "/" + file.path;
      this.urls.push(urlObj);
      this.showImageViewer = true;
    },
    handleClose() {
      this.showImageViewer = false;
    },
    handleExceed(files, fileList) {
      const message = this.$t('common.fileLimitWarning', {
      limit: this.limit,
    });
    this.$message.warning(message); 
    },
  },
  async mounted() {
    await this.showFileByCatgIdBusiKey();
    console.log(this.fileList);
  },
};
</script>
<style lang="scss" scoped>
.upload-common {
  ::v-deep .lls-upload-dragger__list {
    height: 117%;
  }

  .upload-half {
    width: 320px;
  }

  .upload-all {
    width: 720px;

    ::v-deep .lls-upload-dragger {
      width: 720px;
      height: 100px;
    }

    ::v-deep .lls-upload-dragger .lls-upload__text {
      margin: 26px 0 0;
    }
  }

  ::v-deep .lls-dialog__body {
    height: 700px;
    overflow-y: auto;
  }
}
</style>
